module.exports = __webpack_public_path__ + "img/sb15.abbc438e.png";